module.exports = __webpack_public_path__ + "img/avatar7.2ffe2dcb.png";